import React from 'react';
import { CommentList } from '../comments/components/CommentList';
import { CrmRelationType } from '../kanban/projectsKanban/models/CrmRelationType';
import WorkingHours from '../kanban/projectsKanban/components/workingHours';
import InfoBoard from './react-nodes/info-board/InfoBoard';
import RatesAmountStats from './react-nodes/rates-amount-stats/RatesAmountStats';

export const DATA_SOURCE_TO_ENTITY_TYPE: Record<string, number> = {
  TtTask: CrmRelationType.Task,
  TtProject: CrmRelationType.Project,
  CrmRelations: CrmRelationType.CrmRelation,
};

type ReactNodeProps = {
  entityId?: number;
  canCreate?: boolean;
  canEdit?: boolean;
  dataSource?: string;
  value?: unknown;
};

type ReactNodeRenderer = (props: ReactNodeProps) => React.ReactElement | null;

const registry: Record<string, ReactNodeRenderer> = {
  comments: ({ entityId, canCreate, canEdit, dataSource }) => {
    if (!entityId) return null;
    const entityTypeId =
      (dataSource ? DATA_SOURCE_TO_ENTITY_TYPE[dataSource] : undefined) ??
      CrmRelationType.CrmRelation;
    return (
      <CommentList
        entityId={entityId}
        entityTypeId={entityTypeId}
        canAdd={!!(canCreate || canEdit)}
      />
    );
  },

  workingHours: ({ entityId, canCreate, canEdit }) => {
    if (!entityId) return null;
    const disabled = !(canCreate || canEdit);
    return <WorkingHours disabled={disabled} recordId={String(entityId)} />;
  },

  infoBoard: ({ entityId }) =>
    entityId && Number.isFinite(entityId) && entityId > 0 ? (
      <InfoBoard relationId={entityId} />
    ) : null,

  RatesAmountStats: ({ value }) => <RatesAmountStats value={value} />,
};

export function resolveReactNode(
  renderingClass: string | null | undefined,
  props: ReactNodeProps
): React.ReactElement | null {
  if (!renderingClass) return null;
  const renderer = registry[renderingClass];
  if (!renderer) return null;
  return renderer(props);
}
